<app-dialog
[title]="data.title"
  [actions]="actions"
  (action)="action($event)"
  (close)="close()"
>
<mat-dialog-content>
    <div class="unmapped-box py-3">
    <div *ngIf="!data.isItemStockWithNoMapping && !data?.nonDeductedShipmentCount">
        <div class="unmapped-list mb-3"  *ngFor="let item of unmappedSkuDetail">
            <div class="icon-box d-flex align-items-center">
                <span class="icon d-flex align-items-center justify-content-center me-3"><img src="assets/images/account-dropdown/{{item.type | lowercase }}.png" alt=""/></span>
                <span class="item-name" [matTooltip]= "item.name">{{item.name}}</span>
            </div>
            <div class="sku-label d-flex flex-column">
                <label>SKU's</label>
                <span>{{item.skuCount | number: "1.0-2"}}</span>
            </div>
            <div class="mapping-section d-flex align-items-center ms-auto">
                <app-button [buttonSize]="'medium'" [spin]="item.loadingTemplate" (click)="exportUnmapedSku(item)">Download SKUs</app-button>
            </div>
        </div>
    </div>
    <div *ngIf="data.isItemStockWithNoMapping  && !data?.nonDeductedShipmentCount">
        <div class="unmapped-list unmapped-products mt-3">
            <div class="product-label d-flex flex-column">
                <label class="mb-1">Product's</label>
                <span>{{data.productCount | number: "1.0-2"}}</span>
            </div>
            <div class="mapping-section d-flex align-items-center ms-auto">
                <app-button [buttonSize]="'medium'" [spin]="loadExportProduct" (click)="exportProducts()">Download Products</app-button>
            </div>
        </div>
    </div>
    <div *ngIf="!data?.isItemStockWithNoMapping && data?.nonDeductedShipmentCount">
        <div class="unmapped-list mb-3"  *ngFor="let item of shipmentDeductionAlertDetail">
            <div class="icon-box d-flex align-items-center">
                <span class="icon d-flex align-items-center justify-content-center me-3"><img src="assets/images/account-dropdown/{{item.type | lowercase }}.png" alt=""/></span>
                <span class="item-name" [matTooltip]= "item.account">{{item.account}}</span>
            </div>
            <div class="sku-label d-flex flex-column">
                <label>Shipment's</label>
                <span>{{ item.shipmentCount | number: "1.0-2"}}</span>
            </div>
            <div class="mapping-section d-flex align-items-center ms-auto">
                <app-button [buttonSize]="'medium'" [spin]="loadingShipmentExport" (click)="exportDeductShipment(item)">Download Shipments</app-button>
            </div>
        </div>
    </div>
</div>     
<div  class="loader" *ngIf="loading && !data.isItemStockWithNoMapping">
        <img  src="assets/images/nineyard-loading.gif" >
    </div> 
</mat-dialog-content>
</app-dialog>